import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  const pagesOpcion = [
    { title: "Clientes", path: "/clientes", icon: "pi pi-address-book" },
    { title: "Producto/ Servicio", path: "/productoServicio", icon: "pi pi-briefcase" },   
    { title: "Facturación", path: "/facturas", icon: "pi pi-file-check" },
    { title: "Pagos", path: "/pagos", icon: "pi pi-credit-card" },
    { title: "Reportes Facturas", path: "/reportes", icon: "pi pi-receipt" },
    
    { title: "Configuración", path: "/configuracion", icon: "pi pi-cog" }
  ];

  return (
    
    <div className="layout-sidebar" >
      <div className="layout-menu-container">
        <ul className="layout-menu">
          <li className="layout-root-menuitem">
            <div className="layout-menuitem-root-text"><span>Inicio</span></div>
            <Link to="/" className="p-ripple tooltip-target">
              <i className="layout-menuitem-icon pi pi-home"></i>
              <span className="layout-menuitem-text">Dashboard</span>
            </Link>
          </li>

          <div className="sidebar-heading text-center">Catálogos</div>

          {pagesOpcion.map((page, idx) => (
            <li className="layout-root-menuitem " key={idx} title={page.title}>             
              <Link to={page.path} className="sidebar-link  flex flex-col items-center" >
                <i className={`layout-menuitem-icon ${page.icon} text-center`}  >
                   <div class="text-center text-xs">{page.title}</div></i>                                          
              </Link>                 
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
